// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentStatisticsListedTable_main__VWa0w {
    width: 100%;
}

.ComponentStatisticsListedTable_filter__HyXU3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentStatisticsListedTable/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB","sourcesContent":[".main {\n    width: 100%;\n}\n\n.filter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ComponentStatisticsListedTable_main__VWa0w`,
	"filter": `ComponentStatisticsListedTable_filter__HyXU3`
};
export default ___CSS_LOADER_EXPORT___;
